import { render, staticRenderFns } from "./InvBatMtbx.vue?vue&type=template&id=4a2df4de&scoped=true"
import script from "./InvBatMtbx.vue?vue&type=script&lang=js"
export * from "./InvBatMtbx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2df4de",
  null
  
)

export default component.exports